module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_6_preview.94141fb9.jpg";